export default __webpack_public_path__ + "static/Lazada4-ec226747380a7ef49cc357153903e722.jpg";